import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteKiloClass, AthleteKiloClassWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAthleteClass(): UseMutationResult<
  AxiosResponse<AthleteKiloClass>,
  AxiosError<ErrorMessage>,
  AthleteKiloClassWrite
> {
  const queryClient = useQueryClient();

  const createAthleteClass = (
    athleteKiloClass: AthleteKiloClassWrite,
  ): Promise<AxiosResponse<AthleteKiloClass>> => {
    return client.post('athlete-kilo-classes/', athleteKiloClass);
  };

  return useMutation(createAthleteClass, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athleteClasses'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classes'],
      });
      queryClient.invalidateQueries({
        queryKey: 'events',
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['totalAttended'],
      });
      queryClient.invalidateQueries({
        queryKey: ['totalReserved'],
      });
    },
  });
}
